export class MeAviseTipo {
  Id: number;
  Descricao: string;
  Ativo: boolean;

  constructor() {
    this.Id = 0;
    this.Descricao = '';
  }
}
